/* eslint-disable */
import ApiClient from './apiClient';
import { versionCompare } from '../util/common';
import qbJsapi from '../../lib/qb/jsapi';
import Qua from '@tencent/parse-qua';
import compareVersions from 'compare-versions';
import sendBoss from '../base/sendBoss';

class Utils {
	constructor() {
		this.ua = window.navigator.userAgent;
		this.app = this.appDetect();
		this.os = this.osDetect();
	}

	isFunction(value) { return typeof value == "function" }

	appDetect() {
		let result,
			weixin = false,
			mqq = false,
			QQLiveBrowser = false,
			kuaibao = false,
			qqnews = false,
			qb = false,
			version = "";

		// 微信
		if ((result = this.ua.match(/MicroMessenger\/([\d\.]*)/i))) {
			weixin = true;
			version = result[1];
		}

		// 手Q
		else if ((result = this.ua.match(/ QQ[\s\/]([\d\.]*)/i))) {
			mqq = true;
			version = result[1];
		}

		//腾讯视频webview
		else if ((result = this.ua.match(/QQLiveBrowser\/([\d\.]*)/i))) {
			QQLiveBrowser = true;
			version = result[1];
		}

		//看点快报webview
		else if ((result = this.ua.match(/qnreading\/([\d\.]*)/i))) {
			kuaibao = true;
			version = result[1];
		}

		//看点快报大字版webview
		else if ((result = this.ua.match(/qnreadingplus\/([\d\.]*)/i))) {
			kuaibao = true;
			version = result[1];
		}

		//腾讯新闻webview
		else if ((result = this.ua.match(/qqnews\/([\d\.]*)/i))) {
			qqnews = true;
			version = result[1];
		}

		// qq浏览器 加一个URL判断 为了cover住qb浏览器福利中心注入user agent不正确的问题
		else if (((result = this.ua.match(/MQQBrowser\/([\d\.]*)/i))) || window.location.pathname.includes('newtickets') || window.location.pathname.includes('verification')) {
			qb = true;
			version = result ? result[1] : '10.5'; // 10.5是目前的最新版
		}

		return {
			weixin: weixin,
			mqq: mqq,
			QQLiveBrowser: QQLiveBrowser,
			kuaibao: kuaibao,
			qqnews: qqnews,
			qb: qb,
			version: version
		};
	}

	osDetect() {
		let result,
			android = false,
			ios = false,
			iphone,
			ipad,
			ipod,
			version = "";

		// android
		if ((result = this.ua.match(/(Android);?[\s\/]+([\d.]+)?/))) {
			android = true;
			version = result[2];
		} else {
			//ios
			iphone = this.ua.match(/(iPhone\sOS)\s([\d_]+)/);
			ipad = this.ua.match(/(iPad).*OS\s([\d_]+)/);
			ipod = this.ua.match(/(iPod)(.*OS\s([\d_]+))?/);
			if (iphone) {
				version = iphone[2];
				iphone = true;
				ios = true;
			} else if (ipad) {
				version = ipad[2];
				ipad = true;
				ios = true;
			} else if (ipod) {
				version = ipod[2];
				ipod = true;
				ios = true;
			}
		}

		return {
			android: android,
			ios: ios,
			iphone: iphone,
			ipad: ipad,
			ipod: ipod,
			version: version
		};
	}
}

function getPromise() {
	let rtResolve,
		rtReject,
		rtPromise = new Promise((resolve, reject) => {
			rtResolve = resolve;
			rtReject = reject;
		});
	return {
		rtResolve,
		rtReject,
		rtPromise
	};
}

function compareVersion(a, b) {
    a = String(a).split('.');
    b = String(b).split('.');
    try {
        for (var i = 0, len = Math.max(a.length, b.length); i < len; i++) {
            var l = isFinite(a[i]) && Number(a[i]) || 0,
                r = isFinite(b[i]) && Number(b[i]) || 0;
            if (l < r) {
                return -1;
            } else if (l > r) {
                return 1;
            }
        }
    } catch (e) {
        return -1;
    }
    return 0;
}

let guid = 1;

const util = new Utils(),
	{
		rtResolve: readyResolve,
		rtReject: readyReject,
		rtPromise: readyPromise
	} = getPromise();

if (util.os.android && util.app.kuaibao) {
	const script = document.createElement("script");
	script.src = "//mat1.gtimg.com/www/reading/android/js/jsapi/jsapi.js";
	script.async = true;
	script.onload = readyResolve;
	script.onreadystatechange = function() {
		if (this.readyState == "complete") {
			readyResolve();
		}
	};
	document.getElementsByTagName("head")[0].appendChild(script);
} else if ((util.os.iphone || util.os.ipad) && util.app.kuaibao) {
	//ios会复用webview,可能导致跳转时不触发相关事件，且有TencentNews时不一定真的注入了
	if (window.TencentNews && window.__TencentNewsInjected) {
		setTimeout(readyResolve, 0);
	} else {
		document.addEventListener("TencentNewsJSInjectionComplete", function() {
			if (!window.__TencentNewsInjected) {
				window.__TencentNewsInjected = true;
				readyResolve();
			}
		});
	}
} else if(util.app.qb){
	const script = document.createElement("script");
	script.src = "//jsapi.qq.com/get?api=login.getAccountInfo,login.showLoginPanel,login.refreshToken,app.*,,connection.getType,screen.requestFullScreen,screen.getNightmodeEnabled,app.doTokenFeature,bookshelf.setBarTitle,env.*,login.authorize,download.startDownload,download.getDownloadStatus,event.downloadstatuschange,download.pauseDownload,download.installApp,login.getAuthorizeInfo,download.getDownloadInfo,login.logoutAuthorizeInfo,event.onloginUserSwitch,login.enableAccountCookie,qbmarket.*,qb.showPushNotification,event.connectionchange,login.subscribeWXMessage,cloudgame.*,device.*,ad.*,usercenter.reportDataToWelfareCenter,share.*,file.*,bookshelf.isInBookShelf,app.getAppVersion,qb.wxAuth";
	script.async = true;
	script.onload = readyResolve;
	script.onreadystatechange = function() {
		if (this.readyState == "complete") {
			console.log('api ready');
			readyResolve();
		}
	};
	document.getElementsByTagName("head")[0].appendChild(script);
}else {
	console.warn("not ready");
}

const $http =  new ApiClient();

/**
 * [ready description]
 * @returns {Promise}      [description]
 */
function ready() {
	console.log('promise ready start', readyPromise);
	return readyPromise;
}

/**
 * @param {Object} config
 * config: {
 *  shareContentModel: {
 *      link,
 *      title,
 *      desc,
 *      imgUrl
 *  }
 * }
 */
function setShareInfo({ link, title, desc, imgUrl, text }) {
	let { rtResolve, rtReject, rtPromise } = getPromise();

	let callbackName = "gKbCallback" + guid++;
	//安卓下右上角分享无法触发callback
	window[callbackName] = function(res) {
		if (res) {
			if (typeof res == "string") {
				res = JSON.parse(res);
			}
			if (res.success == 1) {
				rtResolve(true);
			} else {
				rtResolve(false);
			}
		}
	};

	if (util.os.android) {
		if(compareVersion(util.app.version, '6.1.10') == - 1) {//低版本走老api
			window.TencentReading.setShareArticleInfo(
				title,
				title,
				desc,
				link,
				imgUrl,
				callbackName
			);
		} else {
			window.TencentReading.setShareArticleInfo(
				title,
				title,
				desc,
				link,
				imgUrl,
				text,
				callbackName
			);
		}
	} else if (util.os.iphone || util.os.ipad) {
		if (callbackName) {
			window.TencentNews.shareCompleteCallback = window[callbackName];
		}
		//设置登录后不刷新
		window.TencentNews.setNoRefreshAfterLogin &&
			window.TencentNews.setNoRefreshAfterLogin(1);


		if(!!util.app.version && compareVersion(util.app.version, '6.1.10') == - 1) {//低版本走老api
			window.TencentNews.setShareArticleInfo &&
			window.TencentNews.setShareArticleInfo(
				title,
				title,
				desc,
				link,
				imgUrl
			);
		} else {  //6.2.30拿不到版本号，强制走最新版本分享
			window.TencentNews.setShareArticleInfo &&
			window.TencentNews.setShareArticleInfo(
				title,
				title,
				desc,
				link,
				imgUrl,
				text
			);
		}
	}
	return rtPromise;
}

/**
 * @param {String} url
 * @param {Object} data
 * @returns {Promise}      [description]
 */
function post(url, data = {}) {
	if (!url) {
		console.warn("url null");
	}

	let { rtResolve, rtReject, rtPromise } = getPromise();

	if(util.app.kuaibao) {
		let successCallbackName = "gKbCallback" + guid++,
		errorCallbackName = "gKbCallback" + guid++,
		iosCallbackName = "gKbCallback" + guid++;

		window[successCallbackName] = function(res) {
			// alert(JSON.stringify(res))
			if (typeof res == "string") {
				try {
					rtResolve(JSON.parse(res));
				} catch (error) {
					console.error(error);
				}
			} else {
				rtResolve(res);
			}
		};

		window[errorCallbackName] = function(res) {
			rtReject(res);
		};

		if (util.os.android) {
			window.TencentReading.postData(
				url,
				JSON.stringify(data),
				successCallbackName,
				errorCallbackName
			);
		} else if (util.os.iphone || util.os.ipad) {
			window[iosCallbackName] = function(res) {
				if (res) {
					res = arguments[1];
					if (typeof res == "string") {
						try {
							rtResolve(JSON.parse(res));
						} catch (error) {
							console.error(error);
						}
					} else {
						rtResolve(res);
					}
				} else {
					rtReject("ios post error");
				}
			};
			// alert(url)
			window.TencentNews.post(url, data, window[iosCallbackName]);
		}
	}else if(util.app.qb) {
		const urlStr = url.split('//')[1] || '';
		const index = urlStr.indexOf('/');
		const pathname = urlStr.substr(index);
		$http.post(pathname, {
			data
		}).then((res) => {
			if (!!res) {
				rtResolve(res);
			} else {
				rtReject(res);
			}
		}).catch(error => {
			console.error(error, 'post error')
			rtReject(error);
		})
	}else {
		rtResolve({});
	}

	return rtPromise;
}

/**
 * 调起分享面板
 * @param  {[String]} config [例如：wechatfriends,wechattimeline,qqfriends,qzone]
 * @return {[type]}        [description]
 */
function showActionMenu(config) {
	if (util.os.iphone || util.os.ipad) {
		if (typeof config === "string") {
			window.TencentNews.showShareMenu(config);
		}

		window.TencentNews.showActionMenu();
	} else if (util.os.android) {
		if (typeof config === "string") {
			window.TencentReading.showShareMenu(config);
		} else {
			window.TencentReading.showActionMenu();
		}
	}
}

/**
 * 设置titleBar
 * @param {[String]} title
 */
function setTitle(title) {
	console.log(title, 'title')
	if (typeof title === "string") {
		if(util.app.kuaibao) {
			if (util.os.android) {
				window.TencentReading.setTitle(title);
			} else if (util.os.iphone || util.os.ipad) {
				window.TencentNews.setTitle(title);
			}
		}else {
			document.title = title;
		}

	}
}

/**
 * 获取APP信息
 */
function getAppInfo() {
	if(util.app.kuaibao) {
		const { rtResolve, rtReject, rtPromise } = getPromise();

		let callbackName = "gKbCallback" + guid++;

		window[callbackName] = function(res) {
			if (typeof res == "string") {
				res = JSON.parse(res);
				if (util.os.ios) {
					res.devid = res.devid;
				} else if (util.os.android) {
					res.devid = res.deviceId;
				}
			}

			rtResolve(res);
		};

		if (util.os.iphone || util.os.ipad) {
			window.TencentNews.getAppInfo(window[callbackName]);
		} else if (util.os.android) {
			window.TencentReading.getAppInfo(callbackName);
		}

		return rtPromise;
	}else if(util.app.qb) {
		return new Promise( (resolve) => {
			if (window.browser && window.browser.app && window.browser.app.getBrowserParam) {
				window.browser.app.getBrowserParam((rst) => {
          try {
            sendBoss('getAppInfo', {
              extra_info: {
                qua: rst.qua ? encodeURIComponent(rst.qua) : '',
                guid: rst.guid || ''
              },
            });
          } catch (error) {
            throw 'window.browser.app.getBrowserParam 上报错误'
          }

					console.log('getBrowserParam rst', rst);
					if (rst && rst.guid) {
						let userBrowserInfo = {
							guid: rst.guid,
							qua: rst.qua
						};
						return resolve(userBrowserInfo);
					} else {
						console.log('getBrowserParam guid not exist');
						return resolve(null);
					}
				}, (err) => {
					console.log('获取guid错误error:', err);
					return resolve(null);
				}, { appID: '116' });
			} else {
			  	console.log('getBrowserParam undefined');
			  	return resolve(null);
			}
		});
	}

}
/**
 * 设置ios触底反弹
 */
function setWebViewBounces(flag = 0) {
	if (util.os.iphone || util.os.ipad) {
		window.TencentNews.setWebViewBounces(flag);
	}
}

/**
 * 禁用分享
 */
function disableShareBtn() {
	if (util.os.android) {
		window.TencentReading.disableShareBtn();
	} else if (util.os.iphone || util.os.ipad) {
		window.TencentNews.setActionBtn(0);
	}
}

/**
 * 获取客户端主账号信息
 * @return {String}    [返回值:qq,wx,sina,phone,huawei]
 */
function getMainAccount() {
	const { rtResolve, rtReject, rtPromise } = getPromise();

	let callbackName = "gKbCallback" + guid++;

	window[callbackName] = function(res) {
		if (typeof res == "string") {
			if (res === "" || !res) {
				rtResolve("unknown");
			} else {
				rtResolve(res.toLocaleLowerCase());
			}
		} else {
			rtResolve("unknown");
		}
	};

	if(util.app.kuaibao) {
		if (util.os.android) {
			window.TencentReading.getMainAccount(callbackName);
		} else if (util.os.iphone || util.os.ipad) {
			window.TencentNews.getMainAccount(window[callbackName]);
		}
	}else {
		rtResolve("unknown");
	}

	return rtPromise;
}

/**
 * 获取微信账号信息
 * @return {JSON}      [用户头像、昵称、openid等]
 */
function getWeixinUserInfo(cb) {
	const { rtResolve, rtReject, rtPromise } = getPromise();

	let callbackName = "gKbCallback" + guid++;

	window[callbackName] = function(res) {
		if (typeof res == "string") {
			res = JSON.parse(res);
		}
		rtResolve(res);
	};

	if (util.os.android) {
		window.TencentReading.getWeixinUserInfo(callbackName);
	} else if (util.os.iphone || util.os.ipad) {
		window.TencentNews.getWeixinUserInfo(window[callbackName]);
	}

	return rtPromise;
}

/**
 * 通过新webview打开
 * @param {[String]} url
 * @param {[String]} type 这个就别改了
 */

function openWebViewWithType(url, cb, type = "1") {
	const { rtResolve, rtReject, rtPromise } = getPromise();

	let callbackName = "gKbCallback" + guid++;

	window[callbackName] = function(res) {
		rtResolve(res);
	};

	if (util.os.android) {
		window.TencentReading.openWebViewWithType(url, type, callbackName);
	} else if (util.os.iphone || util.os.ipad) {
		window.TencentNews.openWebViewWithCloseCallBack(url, callbackName);
	} else {
		console.log("JS Bridge not ready");
	}

	return rtPromise;
}

/**
 * 拉起登录panel，浏览器逻辑
 */
function showLoginPanel (title = '请登录', key_from_where) {
    return new Promise((resolve) => {
		if (window.browser && browser.login && browser.login.showLoginPanel) {
			window.browser.login.showLoginPanel(async (rst) => {
        if (rst && rst.uin)
        {
          sendBoss('element_click', {
            element_type: 'login',
            element_name: 'login_succeed',
            page_id: 'welfareIndex',
          });
          
        // 上报
				// 登陆成功
				window.location.reload();
        } else
        {
          sendBoss('element_click', {
            element_type: 'login',
            element_name: 'login_fail',
            page_id: 'welfareIndex',
          });
				// 登陆失败
				return resolve({
					code: -1,
					msg: '登陆失败'
				});
			}
			}, (err) => {
				// 登陆失败
				console.log(err);
				return resolve({
					code: -1,
					msg: '登陆失败'
				});
			}, { title, appID: '116' });
		} else {
			console.log('checkUserIsLogined == 此处需要登录');
			// alert('此处需要登录，请在QQ浏览器内打开。');
			return resolve(false);
		}
    });
}

/**
 * 拉起登录，快报逻辑
 * @param {Object} loginInfo
 */

function loginWithInfo(
	loginInfo = {
		type: "qqorweixin",
		resetLoginWording: "1",
		wording1: "推荐使用微信或者QQ登录",
		wording2: "记住你的阅读兴趣",
		showDialogLogin: "1",
		from: "fuli_center",
	}
) {
	const { rtResolve, rtReject, rtPromise } = getPromise();

	let callbackName = "gKbCallback" + guid++;
	console.log(util)

	if (util.os.android) {
		window[callbackName] = function(status) {
			if (status) {
				rtResolve(status);
			} else {
				rtReject(false);
			}
			// rtResolve(status)   //debug版不管是否登录成功都会返回0，目前正式版不会
		};
		window.TencentReading.showNativeLoginWithInfo(
			JSON.stringify(loginInfo),
			callbackName,
			"{}"
		);
	} else if (util.os.iphone || util.os.ipad) {
		window[callbackName] = function(status, param, loginSuccess) {
			//loginSuccess是否真的登录成功了
			if (loginSuccess == "1") {
				rtResolve(status, param);
			} else {
				rtReject(status, param);
			}
		};
		window.TencentNews.showNativeLoginWithInfo(
			loginInfo,
			window[callbackName],
			{},
			"1",
			"1",
			"1"
		); //callback, param,
	}

	return rtPromise;
}

/**
 * 清除主账号
 */
function clearMainAccount() {
	if(util.app.kuaibao) {
		if (util.os.android) {
			window.TencentReading.clearMainAccount();
		} else if (util.os.iphone || util.os.ipad) {
			window.TencentNews.clearMainAccount();
		}
	}
}

/**
 *
 * 复制text到剪切板
 */
function copy(text) {
	if (text) {
		if(util.app.kuaibao) {
			if (util.os.android && window.TencentReading) {
				window.TencentReading.copy && window.TencentReading.copy(text);
			} else if (util.os.iphone && window.TencentNews) {
				window.TencentNews.copy && window.TencentNews.copy(text);
			}
		}else if(util.app.qb) {
			if (window.browser && window.browser.device && window.browser.device.copy) {
				window.browser.device.copy('text', (rst) => {
					console.log('copy rst', rst);
				}, (err) => {
					console.log('copy error:', err);
				});
			} else {
			  	console.log('getBrowserParam undefined');
			}
		}
	}
}

/**
 *
 * 打开客户端url
 */
function openUrl(opt) {
	if(util.app.qb) {
		if (window.browser && window.browser.app && window.browser.app.openUrl) {
			window.browser.app.openUrl((rst) => {
				console.log('copy rst', rst);
			}, (err) => {
				console.log('copy error:', err);
			}, opt);
		} else {
			console.log('getBrowserParam undefined');
		}
	}
}

function toast(msg = '') {
	if (window.browser && window.browser.app && window.browser.app.toast) {
		window.browser.app.toast(msg, 1);
	} else {
		console.info('toast msg:', msg);
	}
}

/**
 * 获取网络状态
 */

function getNetworkStatus() {
	const { rtResolve, rtReject, rtPromise } = getPromise();

	let callbackName = "gKbCallback" + guid++;

	window[callbackName] = function(res) {
		rtResolve(res);
	};

	if (util.os.android) {
		window.TencentReading.getNetworkStatus(callbackName);
	} else if (util.os.iphone || util.os.ipad) {
		window.TencentNews.getNetworkStatus(window[callbackName]);
	} else {
		console.log("JS Bridge not ready");
	}

	return rtPromise;
}

/**
 * 禁止左滑退出
 */
function setGestureQuit(flag) {
	if (flag == true) {
		if (util.os.android) {
			window.TencentReading.setGestureQuit(true);
		} else if (util.os.iphone || util.os.ipad) {
			window.TencentNews.setGestureQuit(1);
		}
	} else {
		if (util.os.android) {
			window.TencentReading.setGestureQuit(false);
		} else if (util.os.iphone || util.os.ipad) {
			window.TencentNews.setGestureQuit(0);
		}
	}
}

/**
 * 在客户端内左右滑动时，禁止客户端上下滑动。仅在安卓下面使用
 *
 * @param {boolean} isAllowHorizontalScroll 是否允许左右滑动
 */

function allowHorizontalScroll(isAllowHorizontalScroll = false) {
	if (util.os.android) {
		window.TencentReading.invokeMethod(
			"enableHorizontalScroll",
			isAllowHorizontalScroll
		);
	} else {
		console.log("allowHorizontalScroll only works in Kuaibao Android ");
	}
}

/**
 * 预览图片， 目前安卓端内只支持单页图片
 *
 * @param {Object} imgInfo 图片信息
 * @param {string} imgInfo.src 图片url
 * @param {nubmer} imgInfo.ratio 图片宽高比
 *
 * @param {Array} imgUrls 图片列表 [{ src, ratio }]
 * @param {Array} imgTypes 图片类型 [1,0,0] 1 表示gif图，0表示正常图片
 */

function kbImagePreview(imgInfo, imgUrls = [], imgTypes = []) {
	if (!imgInfo || !imgInfo.src) {
		return console.log("图片链接错误");
	}
	if (util.os.android) {
		// const imgIndex = imgUrls.indexOf(imgSrc) === - 1 ? 0 : imgUrls.indexOf(imgSrc);
		// const jsonStr = JSON.stringify({
		//     imgUrls: imgUrls,
		//     imageTypes: imgTypes
		// });
		window.TencentReading &&
			window.TencentReading.zoomImageSrc &&
			window.TencentReading.zoomImageSrc(imgInfo.src);
	} else {
		const src = imgInfo.src;
		const list = imgUrls.map(item => {
			return {
				src: item.src,
				selected: item.src === src ? 1 : 0,
				//width: item.width || window.innerWidth,
				// height: item.height || (window.innerWidth * item.ratio) || 300
				width: window.innerWidth,
				height: window.innerHeight
			};
		});
		window.TencentNews &&
			window.TencentNews.openPicInWebview &&
			window.TencentNews.openPicInWebview(list);
	}
}

/**
 * 获取通讯录信息,大于5.0.35
 */

function requireContacts() {
	const { rtResolve, rtReject, rtPromise } = getPromise();

	let callbackName = "gKbCallback" + guid++;

	window[callbackName] = function(res) {
		rtResolve(res);
	};

	if (util.os.android) {
		window.TencentReading.invokeMethod("requireContacts", callbackName);
	} else if (util.os.iphone || util.os.ipad) {
		window.TencentNews.requireContacts(window[callbackName]);
	} else {
		console.log("JS Bridge not ready");
	}

	return rtPromise;
}

/**
 * 直接登录能力,安卓大于5.0.45，ios大于5.0.50
 * @param {string} type 登录类型qq或weixin
 */

function directLoginWithType(type) {
	const { rtResolve, rtReject, rtPromise } = getPromise();

	let callbackName = "gKbCallback" + guid++;

	window[callbackName] = function(res) {
		rtResolve(res == true); //安卓返回1，ios返回
	};

	if (util.os.android) {
		window.TencentReading.invokeMethod(
			"directLoginWithType",
			type,
			callbackName
		);
	} else if (util.os.iphone || util.os.ipad) {
		window.TencentNews.directLoginWithType(
			type,
			window[callbackName],
			{},
			"1",
			"1",
			"1"
		);
		// window.TencentNews.directLoginWithType(type, window[callbackName], callbackparam,refreshCurrentUrl,notRefreshAfterLogin)
	} else {
		console.log("JS Bridge not ready");
	}

	return rtPromise;
}

/**
 * 页面显示隐藏时触发
 */
function setVisibleCallback(cb) {
	let callbackName = "gKbCallback" + guid++;

	window[callbackName] = function(res) {
		cb && cb(res);
	};

	if (util.os.android && window.TencentReading) {
		window.TencentReading.invokeMethod("setVisibleCallback", callbackName);
	} else if ((util.os.iphone || util.os.ipad) && window.TencentNews) {
		window.TencentNews.setVisibleCallback &&
			window.TencentNews.setVisibleCallback(window[callbackName]);
	} else {
		console.log("JS Bridge not ready");
	}
}

/**
 * 端内Tab切换刷新策略
 */
function setRefreshCallback(cb) {
	let callbackName = "gKbCallback" + guid++;

	window[callbackName] = function(res) {
		cb && cb(res);
	};

	if (util.os.android && window.TencentReading) {
		window.TencentReading.invokeMethod("setRefreshCallback", callbackName);
	} else if ((util.os.iphone || util.os.ipad) && window.TencentNews) {
		window.TencentNews.setRefreshCallback &&
			window.TencentNews.setRefreshCallback(window[callbackName]);
	} else {
		console.log("JS Bridge not ready");
	}
}

/**
 * 端内上报
 *
 * @param {string} event 事件名
 * @param {Object} params 上报参数
 */

function sendNativeBoss(event, param = {}) {
	if (
		util.os.android &&
		window.TencentReading &&
		window.TencentReading.invokeMethod
	) {
		window.TencentReading.invokeMethod(
			"sendEventToBossCoverParams",
			event,
			JSON.stringify(param)
		);
	} else if (
		(util.os.iphone || util.os.ipad) &&
		window.TencentNews &&
		window.TencentNews.sendEventToBossCoverParams
	) {
		window.TencentNews.sendEventToBossCoverParams(
			event,
			JSON.stringify(param)
		);
	} else {
		console.log("JS Bridge not ready");
	}
}

/**
 * 检查更新
 */
function checkAndUpdateApp() {
	if (util.os.android && window.TencentReading) {
		window.TencentReading.checkAndUpdateApp &&
			window.TencentReading.checkAndUpdateApp();
	}
}

/**
 *
 * shareType参数：
 * 'sina,qq,wxtl,wx,wxwork'
 * showShareMenu参数：
 * 'wechattimeline,wechatfriends'
 * wechattimeline：微信朋友圈 wechatfriends：微信好友 qqfriends：QQ好友 qzone：QQ空间 sinaweibo：新浪微博 collect：收藏 uninterestvideo：取消收藏 copylink：复制链接
 */
function shareImageWithPreview(base64OrUrl, shareType, cb, isDirectShare = "") {
	// isDirectShare为'1'或''
	let callbackName = "gKbCallback" + guid;

	window[callbackName] = function(res) {
		cb(res);
	};
	guid++;

	if (util.os.android && window.TencentReading) {
		window.TencentReading.invokeMethod(
			"shareImageWithPreview",
			base64OrUrl,
			shareType,
			isDirectShare,
			shareType,
			callbackName
		);
	} else if (util.os.iphone && window.TencentNews) {
		if (isDirectShare == "") {
			const nextShareType = shareType
				.replace(/sina/g, "sinaweibo")
				.replace(/qq/g, "qqfriends")
				.replace(/wxtl/g, "wechattimeline")
				.replace(/wx/g, "wechatfriends");
			window.TencentNews.showShareMenu &&
				window.TencentNews.showShareMenu(nextShareType);
		}
		window.TencentNews.resetShareArticleInfo &&
			window.TencentNews.resetShareArticleInfo(); // ios如果设置了文本信息就不能图片分享，需要调用此接口
		window.TencentNews.shareImageWithPreview &&
			window.TencentNews.shareImageWithPreview(
				base64OrUrl,
				isDirectShare,
				shareType,
				window[callbackName]
			);
	}
}

function shareImageWithUrl(url, isDirectShare = "", shareType, cb) {
	//'sina,qq,wxtl,wx,wxwork' isDirectShare为'1'或''
	let callbackName = "gKbCallback" + guid;

	window[callbackName] = function(res) {
		// console.log(1)
		cb(res);
	};
	guid++;

	if (util.os.android && window.TencentReading) {
		window.TencentReading.invokeMethod(
			"shareImageWithUrl",
			url,
			isDirectShare,
			shareType,
			callbackName
		);
	} else if (util.os.iphone && window.TencentNews) {
		window.TencentNews.shareImageWithUrl &&
			window.TencentNews.shareImageWithUrl(
				url,
				isDirectShare,
				shareType,
				window[callbackName]
			);
	}
}

function showWarningTips(tip) {
	if (typeof tip === "string") {
		if (util.os.android) {
			window.TencentReading.showWarningTips(tip);
		} else if (util.os.iphone) {
			window.TencentNews.showTip(tip, 2); // 0 起始 1 成功 2失败
		}
	}
}

function showSuccessTips(tip) {
	if (typeof tip === "string") {
		if (util.os.android) {
			window.TencentReading.showSuccessTips(tip);
		} else if (util.os.iphone) {
			window.TencentNews.showTip(tip, 1); // 0 起始 1 成功 2失败
		}
	}
}

/**
 * 调起客户端退出登录
 */
function openLogoutDialog() {
	if (util.os.android) {
		window.TencentReading.invokeMethod("openLogoutDialog")
	} else if (util.os.iphone) {
		window.TencentNews.openLogoutDialog();
	}
}

/**
 * 关闭当前webview
 */
function closeWebview() {
	if (util.os.android) {
		window.TencentReading.invokeMethod("finishCurrentPage")
	} else if (util.os.iphone) {
		window.TencentNews.closeWebview();
	}
}

/**
 * 拆分渠道直接分享
 * @param {object} config
 * config:{
 * 		shareContentModel:{
 * 			title: '',
 *      	imgUrl: '',
 * 			content: '',
 *      	url: ''
 *  	},
 *  	shareType: ''//wx:微信 wxtl:朋友圈 qq:QQ qzone:QQ空间
 * }
 */
function directShareArticle(config) {
	let { rtResolve, rtReject, rtPromise } = getPromise();
	let callbackName = '';
	if (config && util.isFunction(config.callback)) {
		callbackName = 'gKbCallback' + this.guid

		window[callbackName] = function(res) {
			if (res) {
				if (typeof res == 'string') {
					res = JSON.parse(res)
				}
				rtResolve(res)
			}
		}

		guid++
	}
	if (config && config.shareContentModel && config.shareContentModel.title && config.shareContentModel.url && config.shareType) {
		let shareContent = config.shareContentModel.content || '',
			shareTitle = config.shareContentModel.title,
			shareUrl = config.shareContentModel.url || '',
			shareImgUrl = config.shareContentModel.imgUrl || '',
			iosCallback = callbackName ? window[callbackName] : function(){},
			shareType = config.shareType

		if (util.os.android && window.TencentReading) {
			window.TencentReading.directShareArticle && window.TencentReading.directShareArticle(shareUrl,shareTitle,shareContent,shareImgUrl,'',shareType,callbackName)
		} else if (util.os.iphone && window.TencentNews) {
			// console.log(config)
			window.TencentNews.directShareArticle && window.TencentNews.directShareArticle(shareUrl,shareTitle,shareContent,shareImgUrl,'',shareType,iosCallback, '1')
		}
	}
	return rtPromise
}

/**
 * 设置返回回调
 */
function setBackCallback(cb) {
	let callbackName = "gKbCallback" + guid++;

	window[callbackName] = function(res) {
		cb && cb(res);
	};

	if (util.os.android && window.TencentReading) {
		window.TencentReading.invokeMethod("setBackCallback", callbackName);
	} else if ((util.os.iphone || util.os.ipad) && window.TencentNews) {
		window.TencentNews.setBackCallback &&
			window.TencentNews.setBackCallback(window[callbackName]);
	} else {
		console.log("JS Bridge not ready");
	}
}

/**
 * 重置返回回调
 */
function resetBackCallback() {
	if (util.os.android && window.TencentReading) {
		window.TencentReading.invokeMethod("resetBackCallback");
	} else if ((util.os.iphone || util.os.ipad) && window.TencentNews) {
		window.TencentNews.resetBackCallback &&
			window.TencentNews.resetBackCallback();
	} else {
		console.log("JS Bridge not ready");
	}
}

/**
 * 微信是否安装
 */
 function isWXInstalled() {
	const { rtResolve, rtReject, rtPromise } = getPromise();

	let callbackName = "gKbCallback" + guid++;

	window[callbackName] = function(res) {
		rtResolve(!!res); //安卓返回非空，ios返回true为已安装
	};

	if (util.os.android) {
		window.TencentReading.invokeMethod(
			"getAppVersionName",
			"com.tencent.mm",
			callbackName
		);
	} else if (util.os.iphone || util.os.ipad) {
		window.TencentNews.isWXInstalled(window[callbackName]);
	} else {
		console.log("JS Bridge not ready");
	}

	return rtPromise;
 }

/**
 * QQ是否安装
 */
function isQQInstalled() {
	const { rtResolve, rtReject, rtPromise } = getPromise();

	let callbackName = "gKbCallback" + guid++;

	window[callbackName] = function(res) {
		rtResolve(!!res); //安卓返回非空，ios返回true为已安装
	};

	if (util.os.android) {
		window.TencentReading.invokeMethod(
			"getAppVersionName",
			"com.tencent.mobileqq",
			callbackName
		);
	} else if (util.os.iphone || util.os.ipad) {
		window.TencentNews.isQQInstalled(window[callbackName]);
	} else {
		console.log("JS Bridge not ready");
	}

	return rtPromise;
 }

 /**
 * app版本号对比，仅支持qb
 */
function appVersionComapare(compare_version) {
	if(util.app.qb) {
		return new Promise(resolve => {
			if(window.browser && window.browser.app && window.browser.app.getAppVersion){
				try {
					window.browser.app.getAppVersion(function(version) {
						console.log('version: ',version);
						if(versionCompare(version, compare_version) >= 0) {
							return resolve(true);
						} else {
							return resolve(false);
						}
					});
				} catch(err) {
					console.log('getAppVersion error ', err);
					return resolve(false);
				}
			} else {
				console.log('no getAppVersion jsapi');
				return resolve(false);
			}
		});
	}
 }

 /**
  * 保存图片到本地相册，仅支持qb
  * @param {String} imgData base64编码的图片数据
  * @param {Function} callback (result) 保存成功后的回调
  * {Boolean} result 是否保存成功
  */
function saveImgToGallery(imgData, callback) {
	console.log(imgData, 'imgData')
	if (util.app.qb && window.browser && window.browser.file && window.browser.file.saveImgToGallery) {
		window.browser.file.saveImgToGallery(() => {
			console.log('save success')
		}, {imgData: imgData})
	} else {
		console.log('不支持保存图片到本地')
	}
}


 /**
 * 是否安装app
 */
function checkAppInstallStatus(config) {
	if(config && config.callback && util.isFunction(config.callback) && config.packageName) {
		let callbackName = 'gKbCallback' + guid,
			_this = this

		window[callbackName] = function(res) {//返回值 true false
			if (util.os.iphone) {
				res = arguments[1]//ios res boolean true false
			}
			if(res) {//android res int 0 1
				res = true
			} else {
				res = false
			}
			config.callback(res)
		}
		guid ++

		if (util.os.android && window.TencentReading) {
			window.TencentReading.invokeMethod('checkCanOpenNativeUrl',config.packageName,callbackName,'')
		} else if (util.os.iphone && window.TencentNews) {
			window.TencentNews.checkCanOpenNativeUrl && window.TencentNews.checkCanOpenNativeUrl(config.schema,window[callbackName])
		}
	}
}


/**
 * 打开scheme
 */
function openNativeUrl(config) {
	if(config && config.callback && util.isFunction(config.callback) && config.packageName) {
		let callbackName = 'gKbCallback' + guid,
			_this = this

		window[callbackName] = function(res) {//返回值 true false
			config.callback && config.callback(res)
		}
		guid ++

		if (util.os.android && window.TencentReading) {
			window.TencentReading.openApp(config.scheme, config.packageName);
		} else if ((util.os.iphone || util.os.ipad) && window.TencentNews) {
			window.TencentNews.openNativeUrl(config.scheme, window[callbackName]);
		} else {
			console.log("JS Bridge not ready");
		}
	}
}

// 刷新token
function refreshToken(opts = {}) {
  return new Promise((resolve, reject) => {
    if(window.browser && window.browser.login && window.browser.login.refreshToken) {
      try {
        window.browser.login.refreshToken(opts, (ret) => {
          resolve(ret);
        })
      } catch (error) {
        reject({});
      }
    } else {
      reject({})
    }
  })
}

/**
 * 拉起微信授权
 */
 function wxAuth() {
	return new Promise((resolve) => {
		if (window.browser && window.browser.qb && window.browser.qb.wxAuth) {
			window.browser.qb.wxAuth((ret) => {
				console.log('wxAuth ret', ret);
				if (ret) {
					return resolve(ret);
				}
				return resolve({
					authStatus: 3,
				});
			});
		} else {
			return resolve({
			  authStatus: 3,
			});
		}
	});
}

/**
 * 比较qb版本
 * @param {*} compareVersion 要比较的版本
 * @returns 如果当前版本大于compareVersion则返回true，否则返回false
 */
async function isHighVersion(compareVersion) {
  const qua = await qbJsapi.getQua2();
  if (!qua) return false;
  const curVersion = new Qua(qua).getValueByKey('PPVN');
  if (!curVersion) return false;
  return compareVersions(curVersion, compareVersion) >= 0;
}

export {
	ready,
	post,
	setShareInfo,
	showActionMenu,
	setTitle,
	getAppInfo,
	setWebViewBounces,
	disableShareBtn,
	getMainAccount,
	getWeixinUserInfo,
	openWebViewWithType,
	loginWithInfo,
	showLoginPanel,
	clearMainAccount,
	getNetworkStatus,
	setGestureQuit,
	allowHorizontalScroll,
	kbImagePreview,
	requireContacts,
	directLoginWithType,
	setVisibleCallback,
	setRefreshCallback,
	sendNativeBoss,
	checkAndUpdateApp,
	copy,
	shareImageWithPreview,
	shareImageWithUrl,
	showWarningTips,
	showSuccessTips,
	openLogoutDialog,
	closeWebview,
	directShareArticle,
	setBackCallback,
	resetBackCallback,
	isWXInstalled,
	isQQInstalled,
	appVersionComapare,
	$http,
	saveImgToGallery,
	checkAppInstallStatus,
	openNativeUrl,
	openUrl,
	toast,
  refreshToken,
	wxAuth,
  isHighVersion
};
